import React from "react"
import PropTypes, { oneOfType } from "prop-types"
import Select from 'react-select'
import axios from 'axios';

class SubDistrictSelect extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      ...props,
      sub_districts: [],
      isMounted: false
    }
    this.sub_districtSelected = this.sub_districtSelected.bind(this)
  }

  componentDidMount() {
    let { subDistrictId, districtId } = this.props
    if (subDistrictId) {
      this.getSubDistrictFromId(subDistrictId)
    } else {
      if (districtId) {
        this.getCollection()
      }
    }
  }

  setOptions(response) {
    let options = []
    response.data.map(e => {
      options.push({ id: e.id, text: e.name, value: e.id })
    })
    this.setState({
      sub_districts: options,
      isMounted: true
    })
  }

  getSubDistrictFromId(subDistrictId) {
    axios.get(`${process.env.REACT_APP_API_URL}/sub_districts/${subDistrictId}`)
    .then((response) => {
      let options = [{ id: response.data.id, text: response.data.name, value: response.data.id }]
      this.setState({
        sub_districts: options,
        isMounted: true
      })
    })
    .catch(function (error) {
      console.log(error);
    })
    .then(function () {
      // always executed
    });
  }

  getCollection(query) {
    let params = {
      filter: {}
    }
    if (query) {
      params.filter.name = query
    }
    if (this.props.districtId) {
      params.filter.district_id = this.props.districtId
    }

    axios.get(`${process.env.REACT_APP_API_URL}/sub_districts`, {
      params: params
    })
    .then((response) => {
      this.setOptions(response)
    })
    .catch(function (error) {
      console.log(error);
    })
    .then(function () {
      // always executed
    });
  }

  sub_districtSelected(e) {
    let value = e.value
    if (value !== this.props.subDistrictId && this.state.isMounted) {
      this.props.onChange(value, e)
    }
  }

  render() {
    return (
      <React.Fragment>
        <Select
          className="select2-style"
          onChange={this.sub_districtSelected}
          getOptionLabel={option =>
            `${option.text}`
          }
          value={this.state.sub_districts.filter(option => option.value === this.props.subDistrictId)}
          getOptionValue={option => `${option.id}`}
          options={this.state.sub_districts}
          isDisabled={this.props.disabled}
          placeholder={'ค้นหา...'}
        />
      </React.Fragment>
    );
  }
}

SubDistrictSelect.propTypes = {
  subDistrictId: oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired
  ]),
  districtId: oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired
  ]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

export default SubDistrictSelect
